import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileEditorComponent } from 'src/app/modules/profile-editor/components/profile-editor/profile-editor.component';

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent {

  @ViewChild(ProfileEditorComponent) editor: ProfileEditorComponent;
  
  constructor(
  ) {
    
  }
  
  public update() {
    this.editor.updateProfile();
  }
}
